import { render, staticRenderFns } from "./AlUpload.vue?vue&type=template&id=67c925c7"
import script from "./AlUpload.vue?vue&type=script&lang=js"
export * from "./AlUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports